import React from 'react';
import "./css/CategoryList.css"
import subCategoryIcon from '../.././../Main/Icons/90angle.png';

const CategoryList = ({ listId = 1, categories, checkedCategories, toggle, show, textsub, defaultCat }) => {
  const renderCategories = (categories, isDefaultCat = false, isSubcategory = false) => {

    return (
      <ul style={{ listStyleType: 'none' }} className={isSubcategory ? "subcategoryUL p-0" : "p-0"}>
        {categories.map((category) => {
          const id = `${listId}-${category.id}-${category.headId || 0}`;
          const isCategoryChecked = checkedCategories[id] || false;
          const inputId = `cat-${id}`;
          const isSubcategoryOfDefaultCat = isDefaultCat || category.id === defaultCat;
          return (
            <li key={id} className={isSubcategory ? "subcategoryItem" : ""}>
              {isSubcategory ? (
                <div className="d-flex flex-row mt-1 align-items-center">
                  {/* Dit is de checkbox voor subcategorieën */}
                  <div className='branchIndicator' />
                  <img src={subCategoryIcon}  width='18px' height='18px' className='me-2'/>
                  <div className={isSubcategoryOfDefaultCat ? 'opacity-50' : ''}>
                    <div className="categoryCheckbox">
                      <input id={inputId} type="checkbox" checked={isCategoryChecked} onChange={() => !isSubcategoryOfDefaultCat && toggle(id)} />
                      <label htmlFor={inputId}>{category.name}</label>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className='mt-3 ps-2 ps-md-4'>
                    <div className={isSubcategoryOfDefaultCat ? 'opacity-50' : ''}>
                      <div className="categoryCheckbox">
                        <input id={inputId} type="checkbox" checked={isCategoryChecked} onChange={() => !isSubcategoryOfDefaultCat && toggle(id)} />
                        <label htmlFor={inputId}>{category.name}</label>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {show && isCategoryChecked && !defaultCat && (
                <div className="subcategoryPlaceholder">
                  <div className='branchIndicator' />
                  <label className='user-select-none ps-4'>{textsub}</label>
                </div>
              )}
              {category.subcategories && renderCategories(category.subcategories, isSubcategoryOfDefaultCat, true)}
            </li>
          );
        })}
      </ul>
    );
  };

  return renderCategories(categories);
};

export default CategoryList;
